import React, { useState } from 'react';
import Navbar from '../Components/Navbar/Navbar';
import ReadyTo from '../Components/ReadyTo/ReadyTo';
import Ready from '../Components/Ready/Ready';
import Product from '../Components/Product/Product';
import HearAtConversion from '../Components/HearAt/HearAtConversion';
import HearAtCon from '../Components/HearAtCon/HearAtCon';
import ProductSlider from '../Components/ProductSlider/ProductSlider';
import Result from '../Components/Result/Result';
import Services from '../Components/Services/Services';
import Tiktok from '../Components/Tiktok/Tiktok';
import Accordion from '../Components/Accordion/Accordion';
import Footer from '../Components/Footer/Footer';
import Workwithus from '../Components/Workwithus/Workwithus';
import Competion from '../Components/Competition/Competition';
import ThreeSimpleStep from '../Components/ThreeSImpleStep/ThreeSimpleStep';
import Funnel from '../Components/Funnel/Funnel';
import MeetTheTeam from '../Components/MeetTheTeam/MeetTheTeam';
import LinkedIn from '../Components/LinkedIn/LinkedIn';
import ReasonRaving from '../Components/ReasonRaving/ReasonRaving';
import VerticalSlider from '../Components/VerticalSlider2/VerticalSlider';
// import Vertical2 from '../Components/VerticalSlider/Vertical2';
// import landingPageImage from '../assets/LandingPage.png';
import './Homepage.css';
import Logo from '../Images/landingpage.png';
import LogoSlider from '../Components/LogoSlider/LogoSlider';
import Brands from '../Components/Brands/Brands';

// newly added: list your screenshot filenames here (kept minimal)
// Example: 'shot1.jpg', 'shot2.png', 'shot3.webp'
// const screenshotFiles = [
//   // newly added: prioritize 1.1 - 1.15 first, then others
//   '1.1.png',
//   '1.2.jpg',
//   '1.3.jpg',
//   '1.4.jpg',
//   '1.5.jpg',
//   // remaining images
//   '1.png',
//   '2.png',
//   '5.jpg',  
//   '8.jpg',
//   '8.png',
//   '9.png',
//   '10.png',
//   '11.jpg',

//   '12.jpg',

//   '1.6.jpg',
//   '1.7.JPG',
//   '1.8.jpg',
//   '1.9.jpg',
//   '1.10.jpg',
//   '13.jpg',

//   '14.png',
//   // '16.jpg',
//   '17.jpg',
//   // '18.jpg',
//   '19.jpg',
//   // '20.jpg',
//   '21.jpg',
//   '22.jpg',
//   '23.jpg',
//   // '24.jpg',
//   // '25.JPG',
//   // '26.jpg',
//   '27.PNG',
//   '28.jpg',
//   '29.PNG',
//   // '30.jpg',

//   '1.11.jpg',
//   '1.12.jpg',
//   '1.13.jpg',
//   '1.14.jpg',
//   '1.15.png',
//   '31.jpg',
//   '32.jpg',
//   // '33.jpg',
//   '34.jpg',
//   '35.jpg',
//   '36.jpg',
//   '37.jpg',
//   '38.jpg',
//   // '39.jpg',
//   '40.jpg',
//   '41.jpg',
//   '42.jpg',
//   // '43.jpg',
//   '4c090923-3d8b-4341-bb12-d720b1ac7193.jpg',
// ];

const screenshotCol1 = [
  '1.5.jpg', '1.4.jpg', '1.7.JPG', '1.10.jpg', '1.13.jpg','1.png','8.jpg',
  '12.jpg', '19.jpg', '27.PNG',  '31.jpg', '34.jpg','36.jpg','13.jpg', '32.jpg', '37.jpg',
];

const screenshotCol2 = [
  '1.2.jpg','1.1.png',  '1.8.jpg','1.11.jpg', '1.14.jpg', '2.png','9.png','14.png',
  '17.jpg', '21.jpg', '28.jpg',  '35.jpg','40.jpg','42.jpg',
];

const screenshotCol3 = [
  '1.9.jpg','1.3.jpg', '1.6.jpg',  '1.12.jpg','1.15.png', '5.jpg','8.png', '10.png', '11.jpg',
  '22.jpg','23.jpg', '29.PNG',  '38.jpg', '222.jpg',
];
const reviews = [
  {
    text: 'Sru is super organised and keeps everything moving in the right direction—from socials to newsletters and even launches!',
    avatar:
      'https://framerusercontent.com/images/5P0eN6qtSxQg8Lrk6rw2GR9e7eI.jpg?scale-down-to=1024',
  },
  {
    text: 'She optimised my entire social media process, making it seamless. All I have to do is show up and deliver my message.',
    avatar:
      'https://framerusercontent.com/images/kIBiy2xM79Ac692vRBBeMc3YFw8.jpg?scale-down-to=512',
  },
  {
    text: 'The most creative person I’ve ever met—Sru treats your business as her own.',
    avatar:
      'https://framerusercontent.com/images/RnlZlUp5GcLVlfS43Q4nd6kA9c.jpg?scale-down-to=1024',
  },
  {
    text: 'They completely removed the stress of putting content online.',
    avatar:
      'https://framerusercontent.com/images/oUkBi1c8nERocfQrJWNLxZ9Fipw.jpg?scale-down-to=1024',
  },
  {
    text: 'Always communicative, responsive, and ahead of the game. She delivers on every commitment.',
    avatar:
      'https://framerusercontent.com/images/kIBiy2xM79Ac692vRBBeMc3YFw8.jpg?scale-down-to=512',
  },
  {
    text: 'She planned my marketing with such clarity and precision, helping me attract the right clients.',
    avatar:
      'https://framerusercontent.com/images/5P0eN6qtSxQg8Lrk6rw2GR9e7eI.jpg?scale-down-to=1024',
  },
  {
    text: 'Sru has been key to the success of my new program launch, guiding me through every step of the beta phase.',
    avatar:
      'https://framerusercontent.com/images/RnlZlUp5GcLVlfS43Q4nd6kA9c.jpg?scale-down-to=1024',
  },
  {
    text: 'Her systematised approach has made managing my social media effortless and effective.',
    avatar:
      'https://framerusercontent.com/images/oUkBi1c8nERocfQrJWNLxZ9Fipw.jpg?scale-down-to=1024',
  },
  {
    text: 'Working with her feels like having a true partner who is invested in your success.',
    avatar:
      'https://framerusercontent.com/images/kIBiy2xM79Ac692vRBBeMc3YFw8.jpg?scale-down-to=512',
  },
  {
    text: 'Thanks to her, I never have to worry about staying consistent online.',
    avatar:
      'https://framerusercontent.com/images/5P0eN6qtSxQg8Lrk6rw2GR9e7eI.jpg?scale-down-to=1024',
  },
  {
    text: 'She transformed my marketing into a clear, actionable plan that works.',
    avatar:
      'https://framerusercontent.com/images/RnlZlUp5GcLVlfS43Q4nd6kA9c.jpg?scale-down-to=1024',
  },
  {
    text: 'Sru is a powerhouse who ensures every project stays on track and delivers results.',
    avatar:
      'https://framerusercontent.com/images/oUkBi1c8nERocfQrJWNLxZ9Fipw.jpg?scale-down-to=1024',
  },
  {
    text: 'Her creative strategies and commitment helped take my business to the next level.',
    avatar:
      'https://framerusercontent.com/images/kIBiy2xM79Ac692vRBBeMc3YFw8.jpg?scale-down-to=512',
  },
  {
    text: 'Saryu’s guidance has been instrumental in growing my online presence and launching my programs.',
    avatar:
      'https://framerusercontent.com/images/5P0eN6qtSxQg8Lrk6rw2GR9e7eI.jpg?scale-down-to=1024',
  },
  {
    text: 'She simplifies complex processes and delivers content with precision and consistency.',
    avatar:
      'https://framerusercontent.com/images/kIBiy2xM79Ac692vRBBeMc3YFw8.jpg?scale-down-to=512',
  },
];

const Homepage = () => {
  // newly added: state for lightbox functionality (commented out - image enlarge feature)
  // const [selectedImage, setSelectedImage] = useState(null);

  // const openLightbox = (imageName) => {
  //   setSelectedImage(imageName);
  // };

  // const closeLightbox = () => {
  //   setSelectedImage(null);
  // };

  return (
    <div className='home-container'>
      <div id='about'>
        <Ready />
      </div>
      <div id="brands">
        <Brands />
      </div>

      <div id='reviews'>
        <div className='background-div'></div>
        <HearAtCon />
        <Product />
      </div>

      <div id='product'>
        <div className='background-div'></div>
        <HearAtConversion />
        <Result />
        <ProductSlider />
      </div>

      <div id='services'>
        <div className='background-div'></div>
        <Services />
        <Tiktok />
        <Workwithus />
        <Competion />
      </div>

      <div id='process'>
        <div className='background-div'></div>
        <ThreeSimpleStep />
        <Funnel />
        <ReasonRaving />
        <div className='vertical-slider-container'>
          <div className='vertical-slider slider-1'>
            <VerticalSlider scrollDown={true} reviews={reviews.slice(0, reviews.length / 3)} />
          </div>
          <div className='vertical-slider slider-2'>
            <VerticalSlider scrollDown={false} reviews={reviews.slice(reviews.length / 3, 2 * (reviews.length / 3))}/>
          </div>
          <div className='vertical-slider slider-3'>
            <VerticalSlider scrollDown={true} reviews={reviews.slice(2 * (reviews.length / 3))}/>
          </div>
        </div>
        <div id="faqs">
          <Accordion />
        </div>
        <div id="book-call">
          <ReadyTo />
        </div>

        {/* newly added: Screenshots section below book-call */}
    {/* Fixed 3-column screenshots section */}
    <div id='screenshots' style={{ padding: '2rem 1rem' }}>
          <h2 style={{ color: 'white', textAlign: 'center', margin: '0 0 0.5rem 0' }}>
            Client Results & Social Proof
          </h2>
          <p style={{ color: '#9c9c9c', textAlign: 'center', margin: '0 0 2rem 0' }}>
            Work speaks louder than words
          </p>

          <div
            style={{
              maxWidth: '1400px',
              margin: '0 auto',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '24px',
            }}
          >
            {/* Column 1 */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                minWidth: '280px',
              }}
            >
              {screenshotCol1.map((name) => (
                <img
                  key={name}
                  src={`/assets/ScreenShots/${name}`}
                  alt={name}
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    boxShadow: '0 0 1px white',
                    background: '#0b0b0b',
                    padding: '8px',
                    objectFit: 'contain',
                  }}
                  loading='lazy'
                />
              ))}
            </div>

            {/* Column 2 */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                minWidth: '280px',
              }}
            >
              {screenshotCol2.map((name) => (
                <img
                  key={name}
                  src={`/assets/ScreenShots/${name}`}
                  alt={name}
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    boxShadow: '0 0 1px white',
                    background: '#0b0b0b',
                    padding: '8px',
                    objectFit: 'contain',
                  }}
                  loading='lazy'
                />
              ))}
            </div>

            {/* Column 3 */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                minWidth: '280px',
              }}
            >
              {screenshotCol3.map((name) => (
                <img
                  key={name}
                  src={`/assets/ScreenShots/${name}`}
                  alt={name}
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    boxShadow: '0 0 1px white',
                    background: '#0b0b0b',
                    padding: '8px',
                    objectFit: 'contain',
                  }}
                  loading='lazy'
                />
              ))}
            </div>
          </div>

          {/* Responsive: stack columns on smaller screens */}
          <style>{`
            @media (max-width: 1200px) {
              #screenshots > div {
                flex-direction: column;
              }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};


export default Homepage;
